import { Link } from "react-router-dom";
import { ArrowRight, Video } from "lucide-react";
import { formatPrice } from "@/lib/api";

const DEFAULT_THUMB =
  "https://images.unsplash.com/photo-1478720568477-152d9b164e26?crop=entropy&cs=srgb&fm=jpg&q=85&w=800";

export const VideoCard = ({ video }) => {
  return (
    <Link
      to={`/video/${video.id}`}
      data-testid={`video-card-${video.id}`}
      className="group block bg-[#141414] border border-white/10 hover:border-[#D4AF37]/60 hover:shadow-[0_0_28px_rgba(212,175,55,0.14)] transition-[border-color,box-shadow] duration-300"
    >
      <div className="aspect-video overflow-hidden bg-[#1A1A1A] relative">
        <img
          src={video.thumbnail_url || DEFAULT_THUMB}
          alt={video.title}
          className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
        />
        <span
          data-testid={`video-type-icon-${video.id}`}
          className="absolute top-2.5 left-2.5 flex items-center justify-center bg-black/55 backdrop-blur-sm p-1.5"
        >
          <Video className="w-3.5 h-3.5 text-white" strokeWidth={1.75} />
        </span>
      </div>
      <div className="p-6">
        <p data-testid={`video-category-${video.id}`} className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37]/80 mb-1.5">
          Documentaire
        </p>
        <h3 className="font-display text-xl text-[#F5F3EE] leading-snug">{video.title}</h3>
        {video.short_description && (
          <p className="mt-2 text-sm text-[#8F8F8F] line-clamp-2">{video.short_description}</p>
        )}
        <div className="mt-5 flex items-center justify-between border-t border-white/5 pt-4">
          <span data-testid={`video-price-${video.id}`} className="font-display text-lg text-[#D4AF37]">
            {formatPrice(video.price, video.currency)}
          </span>
          <span
            data-testid={`video-buy-label-${video.id}`}
            className="flex items-center gap-1 text-xs uppercase tracking-widest text-[#D4AF37] border border-[#D4AF37] bg-black/30 px-4 py-2 group-hover:bg-[#D4AF37]/10 group-hover:gap-2 transition-all"
          >
            Acheter <ArrowRight className="w-3.5 h-3.5" />
          </span>
        </div>
      </div>
    </Link>
  );
};
